<mbs-modal
  [title]="baseModal.data?.title || 'shared:quickRestoreModal.title' | i18next"
  [showFooter]="baseModal?.showFooter">
  <ng-container modal-body>
    <ng-container *ngIf="preparing">
      <p *ngIf="needPreparingTextShow; else loader"><span class="loader loader-lg mr-3"></span>Preparing...</p>
      <ng-template #loader>
        <mbs-loader></mbs-loader>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="!preparing || needPreparingTextShow">
      <mbs-alert
        [class.mb-0]="!isWindows && !ignoreIsWindows"
        [type]="mbsPopupType.info"
        [icon]="true">
        {{ 'shared:quickRestoreModal.availabilityAlertText' | i18next }}
      </mbs-alert>

      <ng-container *ngIf="isWindows || ignoreIsWindows">
        <ng-container
          *ngIf="bootableUSBDescription"
          [ngTemplateOutlet]="bootableUSBDescription">
        </ng-container>

        <p class="my-3">{{ 'shared:quickRestoreModal.clickOpenQuickRestore' | i18next }}</p>
        {{ 'shared:quickRestoreModal.ifNothingHappens' | i18next }}
        <mbs-button
          (click)="createQuickRestoreSchema()"
          [isCtrl]="true">
          {{ 'shared:quickRestoreModal.openQuickRestoreButtonText' | i18next }}
        </mbs-button>
        {{ 'shared:quickRestoreModal.toRunQuickRestoreText' | i18next }}
        <ng-container *ngIf="downloadLink">
          <div class="mt-3">
            {{ 'shared:quickRestoreModal.ifProblemsPersists' | i18next }}
            <mbs-button
              (click)="downloadQuickRestore()"
              [isCtrl]="true">
              {{ 'shared:common.download' | i18next }}
            </mbs-button>
            {{ 'shared:quickRestoreModal.installManually' | i18next }}
            <mbs-button
              (click)="createQuickRestoreSchema()"
              [isCtrl]="true">
              {{ 'shared:quickRestoreModal.openQuickRestoreButtonText' | i18next }}
            </mbs-button>
            {{ 'shared:quickRestoreModal.toRunQuickRestoreText' | i18next }}<br />
          </div>
        </ng-container>
        <a
          *ngIf="!bootableUSBDescription && ability.can('read', 'HelpMarketing')"
          href="/AP/Help/restore/quick-restore"
          target="_blank">
          {{ 'shared:buttons.learnMore' | i18next }}
        </a>
      </ng-container>
    </ng-container>
  </ng-container>
</mbs-modal>
